import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import { IDs } from '../../../../../helpers/IDs';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../../../../helpers/RoutingIDs';
import { StandorteEigenstromTabs } from '../../../detail/eigenstrom/StandortEigenstromTabs';
import { StandorteFahrzeuge } from '../../../detail/StandorteFahrzeuge';
import { StandorteMaschinen } from '../../../detail/StandorteMaschinen';
import style from './../../Assistent.less';
import { TriggerService } from '../../../../../core/trigger/trigger_service';
import { WActionButton } from '../../../../../core/elements/WActionButton';

export interface MaschFzgElementProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing?: any;
    standort: any;
}

export interface MaschFzgElementState {
    showErneuerbare: boolean;
    showFahrzeuge: boolean;
    showMaschinen: boolean;
}

export class MaschFzgElement extends React.Component<MaschFzgElementProps, MaschFzgElementState> {

    constructor(props: any) {
        super(props);
        const entity: string = ((props.routing || {}).entity || '').toString();
        this.state = {
            showErneuerbare: entity.startsWith('anlagen_eigenstrom_'),
            showFahrzeuge: entity === 'fahrzeuge',
            showMaschinen: entity === 'maschinen'
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        const konfiguration: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const enableErneuerbareEnergien: boolean = konfiguration.some((param: any) => param.daten_erneuerbare_energien_orig === 1);
        const enableFahrzeuge: boolean = konfiguration.some((param: any) => param.daten_fahrzeuge_orig === 1);
        const enableMaschinen: boolean = konfiguration.some((param: any) => param.daten_maschinen_orig === 1);
        return (
            <div
                className={style.entityForm}
                style={{ margin: 0, borderRadius: '0 0 10px 10px', padding: '0 10px 30px 10px' }}
            >
                {enableFahrzeuge && <>
                    <button
                        style={{ margin: 0 }}
                        className={style.basic}
                        onClick={() => this.setState({ showFahrzeuge: true })}
                    >
                        Energieverbraucher - Fahrzeuge bearbeiten
                    </button>
                </>}
                {enableMaschinen && <>
                    <button
                        style={{ margin: 0, marginTop: 20 }}
                        className={style.basic}
                        onClick={() => this.setState({ showMaschinen: true })}
                    >
                        Energieverbraucher - Maschinen/Anlagen bearbeiten
                    </button>
                </>}
                {enableErneuerbareEnergien && <>
                    <button
                        style={{ margin: 0, marginTop: 20 }}
                        className={style.basic}
                        onClick={() => this.setState({ showErneuerbare: true })}
                    >
                        Energieerzeuger - Erneuerbare Energien bearbeiten
                    </button>
                </>}
                {this.state.showMaschinen && this.renderMaschinenDialog()}
                {this.state.showFahrzeuge && this.renderFahrzeugeDialog()}
                {this.state.showErneuerbare && this.renderErneuerbareDialog()}
            </div>
        );
    }

    renderErneuerbareDialog(): JSX.Element {
        const standort: any = this.props.standort || {};
        return (
            <DialogWrapper2
                width={-1}
                title={`Standort: ${standort.name || ''}`}
                onAfterClose={() => this.setState({ showErneuerbare: false })}
            >
                <div style={{ maxWidth: window.innerWidth - 60 }}>
                    <StandorteEigenstromTabs
                        data={this.props.data}
                        onRoutingChange={() => { }}
                        routing={this.props.routing}
                        standortSelected={standort}
                    />
                </div>
            </DialogWrapper2>
        );
    }

    renderFahrzeugeDialog(): JSX.Element {
        const standort: any = this.props.standort || {};
        return (
            <DialogWrapper2
                width={-1}
                title={`Standort: ${standort.name || ''}`}
                onAfterClose={() => this.setState({ showFahrzeuge: false })}
            >
                <div style={{ maxWidth: window.innerWidth - 60, marginBottom: 10 }}>
                    <StandorteFahrzeuge
                        data={this.props.data}
                        onRoutingChange={() => { }}
                        routing={{}}
                        standortSelected={standort}
                    />
                </div>
            </DialogWrapper2>
        );
    }

    renderMaschinenDialog(): JSX.Element {
        const standort: any = this.props.standort || {};
        return (
            <DialogWrapper2
                width={-1}
                title={`Standort: ${standort.name || ''}`}
                onAfterClose={() => this.setState({ showMaschinen: false })}
            >
                <div style={{ maxWidth: window.innerWidth - 60, marginBottom: 10 }}>
                    <StandorteMaschinen
                        data={this.props.data}
                        onRoutingChange={() => { }}
                        routing={{}}
                        standortSelected={standort}
                    />
                </div>
            </DialogWrapper2>
        );
    }
}
